// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseStepPhase } from './ResponseStepPhase';
import {
  ResponseStepPhaseFromJSON,
  ResponseStepPhaseFromJSONTyped,
  ResponseStepPhaseToJSON,
  ResponseStepPhaseToJSONTyped,
} from './ResponseStepPhase';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';

/**
 *
 * @export
 * @interface ResponseClusterStepDetail
 */
export interface ResponseClusterStepDetail {
  /**
   *
   * @type {boolean}
   * @memberof ResponseClusterStepDetail
   */
  approved?: boolean;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  approvedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  completedAt?: string;
  /**
   * CooldownDurationSeconds is omitted when the step has no cooldown.
   * @type {number}
   * @memberof ResponseClusterStepDetail
   */
  cooldownDurationSeconds?: number;
  /**
   * CooldownEndsAt is only set while the step is cooling down.
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  cooldownEndsAt?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseClusterStepDetail
   */
  index?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  name?: string;
  /**
   *
   * @type {ResponseStepPhase}
   * @memberof ResponseClusterStepDetail
   */
  phase?: ResponseStepPhase;
  /**
   *
   * @type {boolean}
   * @memberof ResponseClusterStepDetail
   */
  requireApproval?: boolean;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseClusterStepDetail
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  selector?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  transferFinishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterStepDetail
   */
  transferStartedAt?: string;
}

/**
 * Check if a given object implements the ResponseClusterStepDetail interface.
 */
export function instanceOfResponseClusterStepDetail(
  value: object,
): value is ResponseClusterStepDetail {
  return true;
}

export function ResponseClusterStepDetailFromJSON(
  json: any,
): ResponseClusterStepDetail {
  return ResponseClusterStepDetailFromJSONTyped(json, false);
}

export function ResponseClusterStepDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterStepDetail {
  if (json == null) {
    return json;
  }
  return {
    approved: json['approved'] == null ? undefined : json['approved'],
    approvedAt: json['approvedAt'] == null ? undefined : json['approvedAt'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    cooldownDurationSeconds:
      json['cooldownDurationSeconds'] == null
        ? undefined
        : json['cooldownDurationSeconds'],
    cooldownEndsAt:
      json['cooldownEndsAt'] == null ? undefined : json['cooldownEndsAt'],
    index: json['index'] == null ? undefined : json['index'],
    name: json['name'] == null ? undefined : json['name'],
    phase:
      json['phase'] == null
        ? undefined
        : ResponseStepPhaseFromJSON(json['phase']),
    requireApproval:
      json['requireApproval'] == null ? undefined : json['requireApproval'],
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    selector: json['selector'] == null ? undefined : json['selector'],
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    transferStartedAt:
      json['transferStartedAt'] == null ? undefined : json['transferStartedAt'],
  };
}

export function ResponseClusterStepDetailToJSON(
  json: any,
): ResponseClusterStepDetail {
  return ResponseClusterStepDetailToJSONTyped(json, false);
}

export function ResponseClusterStepDetailToJSONTyped(
  value?: ResponseClusterStepDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    approved: value['approved'],
    approvedAt: value['approvedAt'],
    completedAt: value['completedAt'],
    cooldownDurationSeconds: value['cooldownDurationSeconds'],
    cooldownEndsAt: value['cooldownEndsAt'],
    index: value['index'],
    name: value['name'],
    phase: ResponseStepPhaseToJSON(value['phase']),
    requireApproval: value['requireApproval'],
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    selector: value['selector'],
    startedAt: value['startedAt'],
    transferFinishedAt: value['transferFinishedAt'],
    transferStartedAt: value['transferStartedAt'],
  };
}
